<template>
  <button
    class="bg-white qmusic:uppercase font-bold text-xl rounded shadow-lg p-2 px-4 hover:bg-opacity-80 transition-colors duration-300 joe:rounded-3xl joe:px-5 joe:py-3 joe:font-medium joe-be:rounded-3xl joe-be:px-5 joe-be:py-3 joe-be:font-medium"
  >
    <slot />
  </button>
</template>
